import type { ButtonProps } from 'aui';
import { Button } from 'aui';
import { useCallback, useEffect, useRef, useState } from 'react';

const useCountdown = ({
  active,
  duration,
  interval,
  onFinish,
}: {
  active: boolean;
  duration: number;
  interval: number;
  onFinish?: any;
}) => {
  const [countdown, setCountdown] = useState(duration);
  const timerRef = useRef<number>();

  const onReset = useCallback(() => {
    setCountdown(duration);
    clearInterval(timerRef.current);
    onFinish?.();
  }, [duration, onFinish]);

  const onTrigger = useCallback(() => {
    timerRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          onReset();
          return duration;
        }
        return prev - 1;
      });
    }, interval * 1000) as unknown as number;
  }, [onReset, duration, interval]);

  useEffect(() => {
    if (active) {
      onTrigger();
    } else {
      onReset();
    }
  }, [active]);

  return countdown;
};
const CountDownButton = ({
  showCountdown,
  asButton,
  onFinish,
  duration = 60,
  interval = 1,
  ...props
}: ButtonProps & {
  showCountdown: boolean;
  asButton?: boolean;
  onFinish?: any;
  duration?: number;
  interval?: number;
}) => {
  const countdown = useCountdown({ active: showCountdown, duration, interval, onFinish });

  if (showCountdown) {
    return asButton ? (
      <Button {...props} disabled>
        {countdown}s
      </Button>
    ) : (
      <span className="px-4" style={{ color: 'var(--app-text-primary-high)' }}>
        {countdown}s
      </span>
    );
  }
  return <Button {...props}>{props?.children}</Button>;
};
export default CountDownButton;
